import React, { useState } from 'react';
import { WidgetsImg } from './img/WidgetsImg';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { AddWidgetModal } from '../AddWidgetModal/AddWidgetModal';
import { WidgetsDTO } from '../../api/useWidgetsQuery';
import { TabSlug } from '../../types';

interface Props {
  tab: TabSlug;
  widgets: WidgetsDTO;
  isFirmLevelUser: boolean;
}

export const DesktopWidgetsEmpty = ({ tab, widgets, isFirmLevelUser }: Props) => {
  const [isAddWidgetModalOpen, setIsAddWidgetModalOpen] = useState(false);

  return (
    <>
      <Box display="flex" flexDirection="column" alignItems="center" my="40" css="gap: 16px">
        <WidgetsImg />

        <Text fontSize="h3" fontWeight={600} color="neutral.600">
          {isFirmLevelUser ? 'Start building your view' : 'No Information Available to Display'}
        </Text>

        {isFirmLevelUser && (
          <Text as="p" maxWidth={475} textAlign="center">
            Add cards to your view from the Card Library. You can access the card library at any
            time by clicking on the Add Card button
          </Text>
        )}

        {isFirmLevelUser && (
          <Button onClick={() => setIsAddWidgetModalOpen(true)}>Add a Card</Button>
        )}
      </Box>

      {isAddWidgetModalOpen && (
        <AddWidgetModal
          tab={tab}
          widgets={widgets}
          onClose={() => setIsAddWidgetModalOpen(false)}
        />
      )}
    </>
  );
};
